import {
  FILE_VALIDATER,
  GET_JOB_STATUS_DETAILS
} from '../constants/actionTypes';
import { PENDING, SUCCESS, ERROR } from '../constants/status';
import enLocaleData from '../i18n/en-EN';

export const initialState = {
  fileValidatorResponse: {},
  isProcessingFileValidation: false,
  isFileValidationFail: false,
  fetched: false,
  error: null,
  isProcessingJobDetails: false,
  fetchedJobDetailsData: null,
  fetchedJobDetailsError: null,
  ...enLocaleData
};

const homePage = (state = initialState, action) => {
  const { type, response, error } = action;
  switch (type) {
    case `${FILE_VALIDATER}_${PENDING}`:
      return {
        ...state,
        isProcessingFileValidation: true,
        fetched: false,
        isFileValidationFail: false
      };
    case `${FILE_VALIDATER}_${SUCCESS}`:
      return {
        fileValidatorResponse: response,
        isProcessingFileValidation: false,
        fetched: true,
        error: null,
        isFileValidationFail: false
      };
    case `${FILE_VALIDATER}_${ERROR}`:
      return {
        ...state,
        fileValidatorResponse: error,
        isProcessingFileValidation: false,
        isFileValidationFail: true,
        fetched: false
      };
    case `${GET_JOB_STATUS_DETAILS}_${PENDING}`:
      return {
        ...state,
        isProcessingJobDetails: true,
        fetchedJobDetailsData: null
      };
    case `${GET_JOB_STATUS_DETAILS}_${SUCCESS}`:
      return {
        fetchedJobDetailsData: response,
        isProcessingJobDetails: false,
        fetched: true,
        error: null
      };
    case `${GET_JOB_STATUS_DETAILS}_${ERROR}`:
      return {
        ...state,
        fetchedJobDetailsData: null,
        isProcessingJobDetails: false,
        fetched: false,
        isFileValidationFail: true
      };
    default: {
      return state;
    }
  }
};

export default homePage;
